const STORAGE_PREFIX = 'velko:chunk-reload';

const CHUNK_ERROR_PATTERNS = [
  /failed to fetch dynamically imported module/i,
  /error loading dynamically imported module/i,
  /importing a module script failed/i,
  /chunkloaderror/i,
  /loading chunk .+ failed/i,
  /load failed/i,
];

function errorText(error: unknown): string {
  if (error instanceof Error) return `${error.name}: ${error.message}`;
  return String(error);
}

function attemptKey(destination: string): string {
  const version = typeof __APP_VERSION__ === 'undefined' ? 'development' : __APP_VERSION__;
  return `${STORAGE_PREFIX}:${version}:${destination}`;
}

export function isChunkLoadError(error: unknown): boolean {
  const text = errorText(error);
  return CHUNK_ERROR_PATTERNS.some((pattern) => pattern.test(text));
}

export function hasChunkReloadAttempt(destination: string): boolean {
  try {
    return sessionStorage.getItem(attemptKey(destination)) === '1';
  } catch {
    return true;
  }
}

export function markChunkReloadAttempt(destination: string): void {
  try {
    sessionStorage.setItem(attemptKey(destination), '1');
  } catch {
    // If storage is unavailable, do not retry repeatedly.
  }
}
